import { LoaderState } from '$core/shell/header/loader/loader';
import { Injectable } from '@angular/core';
import {
  NavigationError,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  public loaderState = this.loaderSubject.asObservable();

  constructor(private router: Router) {
    this.checkRouterEvents();
  }

  public show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  public hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

  /**
   * @description Shows activity Indicator while loading a lazy loaded Module
   * @private
   */
  private checkRouterEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.show();
      } else if (
        event instanceof RouteConfigLoadEnd ||
        event instanceof NavigationError
      ) {
        this.hide();
      }
    });
  }
}
